import { Link } from 'react-router-dom';

export const LoginIntro = () => {
  return (
    <div className="left">
        <h1>
            Nexia Social.
        </h1>

        <p>
            Join a vibrant community of developers, tech enthusiasts, and creative minds. Connect, dive into deep discussions, share your knowledge, and level up together.
        </p>

        <span>
            Don't you have an account?
        </span>

        <Link to="/register">
            <button>
                Register
            </button>
        </Link>
    </div>
  );
};